<template>
    <div>
        <b-modal
            id="create"
            title="Criar Turma"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit="submit" @submit.stop.prevent>

                    <!-- Field -->
                    <b-form-group
                        label="Nome da Turma">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                            :state="hasErrors('name', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        v-if="externalLinkGroup"
                        label="Link Externo">
                        <!-- Input -->
                        <b-form-input
                            placeholder="Ex: https://classroom.google.com/u334gh..."
                            v-model="form.external_link"
                            :state="hasErrors('external_link', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="external_link" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        description="Quando os seus alunos dessa turma entrarem na plataforma, eles poderão assistir o vídeo do painel inicial."
                        label="Vídeo Painel Inicial">
                        <!-- Input -->
                        <b-form-input
                            placeholder="Ex: https://youtube.com..., https://vimeo.com/..."
                            v-model="form.tutorial"
                            :state="hasErrors('tutorial', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="tutorial" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        v-if="telegramByGroup"
                        label="Link Telegram"
                        description="Usado para redirecionar para o suporte dos alunos da turma">
                        <!-- Input -->
                        <b-form-input
                            placeholder="Ex: https://t.me/meu-perfil"
                            v-model="form.telegram_number"
                            :state="hasErrors('telegram_number', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="telegram_number" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Matriculas por Código da Turma">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.open"
                            name="open"
                            switch>

                            <span v-if="form.open">
                                As matrículas por código da turma <b>estão abertas</b>. Bastará o aluno inserir o código para ingressar.
                            </span>

                            <span v-else>
                                As matrículas por código da turma <b>estão fechadas</b>. O aluno não conseguirá ingressar. O ingresso será feito pelo administrador manualmente.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="open" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Envio de Redações dos Alunos">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.send_essay"
                            name="send_essay"
                            switch>

                            <span v-if="form.send_essay">
                                Os alunos não estão impedidos de enviar redação para a plataforma.
                            </span>

                            <span v-else>
                                Os alunos estão impedidos de enviar redação para a plataforma.
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="send_essay" />
                    </b-form-group>

                    <b-form-group
                        label="Créditos ao Entrar na Turma">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.add_credit"
                            name="add_credit"
                            switch>

                                <span v-if="form.add_credit">
                                    Os Alunos irão entrar na turma com os creditos definidos.
                                </span>

                                <span v-else>
                                    Os Alunos não entrarão com uma quantidade de creditos defindos nesta turma
                                </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="add_credit" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        v-if="telegram"
                        label="Link do Telegram">

                        <!-- Input -->
                        <b-form-checkbox
                            v-model="form.telegram_enabled"
                            name="telegram_enabled"
                            switch>

                            <span v-if="form.telegram_enabled">
                                Os alunos desta turma <b>terão acesso</b> ao link do telegram do professor
                            </span>

                            <span v-else>
                                Os alunos desta turma <b>não terão acesso</b> ao link do telegram do professor
                            </span>

                        </b-form-checkbox>

                        <!-- Error -->
                        <has-errors :errors="errors" name="telegram_enabled" />
                    </b-form-group>

                    <b-form-group
                        v-if="form.add_credit"
                        label="Quantidade de créditos iniciais"
                        description="Defina a quantidade de créditos que os alunos recebem ao entrar na turma">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.credit"
                            type="number"
                            :state="hasErrors('credit', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="credit" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Mensagem na Tela Inicial dos Alunos"
                        description="Você pode colocar uma mensagem curta para que os alunos leiam ao entrar na plataforma">
                        <!-- Input -->
                        <b-form-input
                            v-model="form.message"
                            :state="hasErrors('message', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="message" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Criar Turma
                    </b-button>

                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['endpoint', 'externalLinkGroup', 'telegramByGroup', 'telegram'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                open: true,
                external_link: null,
                telegram_number: null,
                send_essay: true,
                telegram_enabled: true,
                message: null,
                tutorial: null,
                credit: null,
                add_credit: false
            }
        }
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post(this.endpoint, this.form)
                .then((result) => {
                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('create')

                    // Message
                    this.$toast.success('Turma criada com sucesso !')

                    // Clear Form
                    this.form = {
                        name: null,
                        open: true,
                        external_link: null,
                        telegram_number: null,
                        send_essay: true,
                        telegram_enabled: true,
                        message: null,
                        tutorial: null,
                        add_credit: null,
                        credit: null,
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
